import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DashboardIcon } from "../icon/icon";
import { notAllowFooter, routes } from "../helpers/constants";
import { checkIsEnable } from "../helpers/commonFunction";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const handleChangePage = (tab) => {
    navigate(tab.to);
  };

  const getFooterLinks = () => {
    return [
      {
        to: routes.dashboard,
        icon: DashboardIcon,
        label: "Home",
        isActive: checkIsEnable(routes.dashboard),
        disabled: false,
        activePages: [routes.dashboard],
      },
    ];
  };

  return (
    <>
      {!notAllowFooter.includes(location?.pathname) && (
        <footer className="tc-footer">
          <div
            className={`tc-footer-content ${
              getFooterLinks()?.length < 2
                ? "justify-content-center"
                : getFooterLinks()?.length < 4
                  ? "justify-content-around"
                  : ""
            }`}
          >
            {getFooterLinks().map((tab, i) => {
              if (tab.isActive) {
                return (
                  <span
                    key={i}
                    role="button"
                    onClick={() => handleChangePage(tab)}
                    className={`tc-footer-tab ${
                      location.pathname === tab.to ? "active" : ""
                    } ${tab.disabled && "pe-none"}`}
                  >
                    {tab.icon}
                    {tab.label}
                  </span>
                );
              } else {
                return null;
              }
            })}
          </div>
        </footer>
      )}
    </>
  );
};

export default Footer;
